import { USER_TYPE } from '../constants/userConstants';
import { useUserIdentityStore } from '../stores/userIdentityStore';
/**
 * Derive the capability matrix for a user type. Pure — safe outside React. `undefined`
 * covers legacy rows without the field and not-yet-loaded subjects; both fall through to
 * `hasMicrosoftAccount`, matching the `!== EXTERNAL` convention documented on `USER_TYPE``.
 */ export var getCapabilitiesForUserType = function getCapabilitiesForUserType(userType, mail) {
    var hasMicrosoftAccount = userType !== USER_TYPE.EXTERNAL;
    return {
        todoSync: hasMicrosoftAccount,
        presence: hasMicrosoftAccount,
        excelSync: hasMicrosoftAccount,
        plannerSync: hasMicrosoftAccount,
        powerbi: hasMicrosoftAccount,
        powerAutomate: hasMicrosoftAccount,
        m365Groups: hasMicrosoftAccount,
        peopleSuggestions: hasMicrosoftAccount,
        teamsDeepLinks: hasMicrosoftAccount,
        outlookCompose: hasMicrosoftAccount,
        export: hasMicrosoftAccount || Boolean(mail),
        redeemReward: hasMicrosoftAccount || Boolean(mail),
        suggestFeature: hasMicrosoftAccount || Boolean(mail),
        referralProgram: hasMicrosoftAccount || Boolean(mail),
        sendMeetingSummary: hasMicrosoftAccount || Boolean(mail),
        sendMeetingLink: hasMicrosoftAccount || Boolean(mail),
        sendReminder: hasMicrosoftAccount || Boolean(mail)
    };
};
/**
 * Whether the viewer is an external (CIAM) user. For non-React callers (stores, helpers).
 */ export var isExternalUser = function isExternalUser() {
    return useUserIdentityStore.getState().userType === USER_TYPE.EXTERNAL;
};
/**
 * Capability matrix for the signed-in viewer, outside React (stores, helpers).
 */ export var getViewerCapabilities = function getViewerCapabilities() {
    var _useUserIdentityStore_getState = useUserIdentityStore.getState(), userType = _useUserIdentityStore_getState.userType, mail = _useUserIdentityStore_getState.mail;
    return getCapabilitiesForUserType(userType, mail);
};
/**
 * Capability matrix for the signed-in viewer, as a hook. Subscribes only to `userType` and
 * `mail`, so components re-render only when either changes.
 *
 * @example
 *   const { todoSync, export: canExport } = useCapabilities()
 *   {todoSync && <TodoSyncBanner />}
 */ export var useCapabilities = function useCapabilities() {
    var userType = useUserIdentityStore(function(state) {
        return state.userType;
    });
    var mail = useUserIdentityStore(function(state) {
        return state.mail;
    });
    return getCapabilitiesForUserType(userType, mail);
};
